// src/config/api.js - API Configuration
const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL,
};

export default API_CONFIG;